
export type TextureSource = HTMLImageElement | {
    width: number;
    height: number;
    data?: Uint8Array;
};

export const createTexture = (gl: WebGLRenderingContext, source: TextureSource): WebGLTexture => {

    const texture = gl.createTexture();

    gl.bindTexture(gl.TEXTURE_2D, texture);

    if (source instanceof HTMLImageElement) {
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, source);
    } else {
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, source.width, source.height, 0, gl.RGBA, gl.UNSIGNED_BYTE, (source.data ?? null) as ArrayBufferView|null);
    }

    const generateMipmaps = isPowerOf2(source.width) && isPowerOf2(source.height);

    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, generateMipmaps ? gl.LINEAR_MIPMAP_LINEAR : gl.LINEAR);

    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);

    if (generateMipmaps) {
        gl.generateMipmap(gl.TEXTURE_2D);
    }
    // @ts-ignore
    return texture;
};

const isPowerOf2 = (n: number): boolean => (!!n) && !(n & (n - 1));